import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const BalanceContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 192px;
    padding-top: 64px;
    box-sizing: border-box;

    ${media.tablet720} {
        min-height: 216px;
        padding-top: 88px;
    }
`;
export const SumContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
    padding: 4px 8px 8px 8px;
    border-radius: 12px;
    cursor: ${(props) => (props.$showCursor ? 'pointer' : 'default')};

    &:hover {
        background: ${(props) => props.theme.white};
    }

    &:active {
        background: ${(props) => props.theme.white_40_tr_base};
    }
`;
export const Sum = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 8px;
`;
export const PseudoDropdown = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;
